module.exports = {
	"ha": "bc",
	"id": 5.5,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category and MSM Status, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 93.29268292682927,
						"dataLabels": {
							"enabled": false,
							"format": "153"
						},
						"color": "#043f61"
					},
					{
						"y": 92.6829268292683,
						"dataLabels": {
							"enabled": false,
							"format": "152"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.58536585365853,
						"dataLabels": {
							"enabled": false,
							"format": "142"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.21951219512195,
						"dataLabels": {
							"enabled": false,
							"format": "125"
						},
						"color": "#09472e"
					},
					{
						"y": 63.41463414634146,
						"dataLabels": {
							"enabled": false,
							"format": "104"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.74105621805792,
						"dataLabels": {
							"enabled": false,
							"format": "562"
						},
						"color": "#043f61"
					},
					{
						"y": 87.9045996592845,
						"dataLabels": {
							"enabled": false,
							"format": "516"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.98637137989779,
						"dataLabels": {
							"enabled": false,
							"format": "493"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.66098807495742,
						"dataLabels": {
							"enabled": false,
							"format": "450"
						},
						"color": "#09472e"
					},
					{
						"y": 62.862010221465084,
						"dataLabels": {
							"enabled": false,
							"format": "369"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.74557165861513,
						"dataLabels": {
							"enabled": false,
							"format": "607"
						},
						"color": "#043f61"
					},
					{
						"y": 90.17713365539453,
						"dataLabels": {
							"enabled": false,
							"format": "560"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.95652173913044,
						"dataLabels": {
							"enabled": false,
							"format": "540"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.19323671497585,
						"dataLabels": {
							"enabled": false,
							"format": "498"
						},
						"color": "#09472e"
					},
					{
						"y": 66.18357487922705,
						"dataLabels": {
							"enabled": false,
							"format": "411"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.45538332635107,
						"dataLabels": {
							"enabled": false,
							"format": "2374"
						},
						"color": "#043f61"
					},
					{
						"y": 95.72685379136992,
						"dataLabels": {
							"enabled": false,
							"format": "2285"
						},
						"color": "#0c4250"
					},
					{
						"y": 93.171344784248,
						"dataLabels": {
							"enabled": false,
							"format": "2224"
						},
						"color": "#0d4440"
					},
					{
						"y": 89.69417679095099,
						"dataLabels": {
							"enabled": false,
							"format": "2141"
						},
						"color": "#09472e"
					},
					{
						"y": 77.20988688730624,
						"dataLabels": {
							"enabled": false,
							"format": "1843"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 90.2439024390244,
						"dataLabels": {
							"enabled": false,
							"format": "37"
						},
						"color": "#043f61"
					},
					{
						"y": 85.36585365853658,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.48780487804879,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#0d4440"
					},
					{
						"y": 60.97560975609756,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#09472e"
					},
					{
						"y": 43.90243902439025,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.55102040816327,
						"dataLabels": {
							"enabled": false,
							"format": "239"
						},
						"color": "#043f61"
					},
					{
						"y": 93.87755102040816,
						"dataLabels": {
							"enabled": false,
							"format": "230"
						},
						"color": "#0c4250"
					},
					{
						"y": 89.38775510204081,
						"dataLabels": {
							"enabled": false,
							"format": "219"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.6530612244898,
						"dataLabels": {
							"enabled": false,
							"format": "178"
						},
						"color": "#09472e"
					},
					{
						"y": 48.16326530612245,
						"dataLabels": {
							"enabled": false,
							"format": "118"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.7012987012987,
						"dataLabels": {
							"enabled": false,
							"format": "532"
						},
						"color": "#043f61"
					},
					{
						"y": 97.21706864564007,
						"dataLabels": {
							"enabled": false,
							"format": "524"
						},
						"color": "#0c4250"
					},
					{
						"y": 93.69202226345084,
						"dataLabels": {
							"enabled": false,
							"format": "505"
						},
						"color": "#0d4440"
					},
					{
						"y": 82.56029684601113,
						"dataLabels": {
							"enabled": false,
							"format": "445"
						},
						"color": "#09472e"
					},
					{
						"y": 52.319109461966605,
						"dataLabels": {
							"enabled": false,
							"format": "282"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.04270462633453,
						"dataLabels": {
							"enabled": false,
							"format": "1653"
						},
						"color": "#043f61"
					},
					{
						"y": 93.8908659549229,
						"dataLabels": {
							"enabled": false,
							"format": "1583"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.27283511269276,
						"dataLabels": {
							"enabled": false,
							"format": "1522"
						},
						"color": "#0d4440"
					},
					{
						"y": 84.04507710557533,
						"dataLabels": {
							"enabled": false,
							"format": "1417"
						},
						"color": "#09472e"
					},
					{
						"y": 62.51482799525504,
						"dataLabels": {
							"enabled": false,
							"format": "1054"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 54,
						"dataLabels": {
							"enabled": false,
							"format": "108"
						},
						"color": "#043f61"
					},
					{
						"y": 49,
						"dataLabels": {
							"enabled": false,
							"format": "98"
						},
						"color": "#0c4250"
					},
					{
						"y": 47,
						"dataLabels": {
							"enabled": false,
							"format": "94"
						},
						"color": "#0d4440"
					},
					{
						"y": 40.5,
						"dataLabels": {
							"enabled": false,
							"format": "81"
						},
						"color": "#09472e"
					},
					{
						"y": 31.5,
						"dataLabels": {
							"enabled": false,
							"format": "63"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 85,
						"dataLabels": {
							"enabled": false,
							"format": "272"
						},
						"color": "#043f61"
					},
					{
						"y": 75.625,
						"dataLabels": {
							"enabled": false,
							"format": "242"
						},
						"color": "#0c4250"
					},
					{
						"y": 71.875,
						"dataLabels": {
							"enabled": false,
							"format": "230"
						},
						"color": "#0d4440"
					},
					{
						"y": 64.0625,
						"dataLabels": {
							"enabled": false,
							"format": "205"
						},
						"color": "#09472e"
					},
					{
						"y": 47.1875,
						"dataLabels": {
							"enabled": false,
							"format": "151"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 87.32612055641422,
						"dataLabels": {
							"enabled": false,
							"format": "565"
						},
						"color": "#043f61"
					},
					{
						"y": 67.69706336939721,
						"dataLabels": {
							"enabled": false,
							"format": "438"
						},
						"color": "#0c4250"
					},
					{
						"y": 64.91499227202473,
						"dataLabels": {
							"enabled": false,
							"format": "420"
						},
						"color": "#0d4440"
					},
					{
						"y": 59.04173106646059,
						"dataLabels": {
							"enabled": false,
							"format": "382"
						},
						"color": "#09472e"
					},
					{
						"y": 47.75888717156105,
						"dataLabels": {
							"enabled": false,
							"format": "309"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 85.45073375262055,
						"dataLabels": {
							"enabled": false,
							"format": "2038"
						},
						"color": "#043f61"
					},
					{
						"y": 59.79035639412999,
						"dataLabels": {
							"enabled": false,
							"format": "1426"
						},
						"color": "#0c4250"
					},
					{
						"y": 56.9811320754717,
						"dataLabels": {
							"enabled": false,
							"format": "1359"
						},
						"color": "#0d4440"
					},
					{
						"y": 54.50733752620545,
						"dataLabels": {
							"enabled": false,
							"format": "1300"
						},
						"color": "#09472e"
					},
					{
						"y": 45.24109014675052,
						"dataLabels": {
							"enabled": false,
							"format": "1079"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -6.707317073170726,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -0.6535947712418277,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.578947368421051,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.971830985915489,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.800000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.258943781942081,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.185053380782914,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.457364341085269,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.722109533468558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.254428341384862,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.742998352553543,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.777777777777772,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.469879518072283,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.5446166736489344,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.748946925021057,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.669584245076584,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.732014388489213,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.918729565623543,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -9.756097560975608,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.405405405405405,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.714285714285716,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.242424242424242,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.4489795918367308,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.765690376569042,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.7826086956521685,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.721461187214615,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.70786516853933,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.2987012987012991,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.5037593984962405,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.62595419847328,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.881188118811881,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -36.629213483146074,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.9572953736654797,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.234724742891716,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.8534428300694867,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.898817345597896,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.61750176429075,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -46,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.259259259259256,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.081632653061229,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.829787234042556,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -15.000000000000002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.029411764705888,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.958677685950407,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.869565217391308,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.34146341463415,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -12.67387944358578,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.477876106194692,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.109589041095896,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.04761904761905,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.10994764397905,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -14.549266247379455,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.029440628066727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.698457223001407,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.341427520235463,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=164"
			},
			{
				"x": 9,
				"text": "30-39<br>n=587"
			},
			{
				"x": 15,
				"text": "40-49<br>n=621"
			},
			{
				"x": 21,
				"text": ">=50<br>n=2387"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=41"
			},
			{
				"x": 34,
				"text": "30-39<br>n=245"
			},
			{
				"x": 40,
				"text": "40-49<br>n=539"
			},
			{
				"x": 46,
				"text": ">=50<br>n=1686"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=200"
			},
			{
				"x": 59,
				"text": "30-39<br>n=320"
			},
			{
				"x": 65,
				"text": "40-49<br>n=647"
			},
			{
				"x": 71,
				"text": ">=50<br>n=2385"
			}
		],
		"dataTable": {
			"MSM:<30": [
				164,
				153,
				152,
				142,
				125,
				104
			],
			"MSM:30-39": [
				587,
				562,
				516,
				493,
				450,
				369
			],
			"MSM:40-49": [
				621,
				607,
				560,
				540,
				498,
				411
			],
			"MSM:>=50": [
				2387,
				2374,
				2285,
				2224,
				2141,
				1843
			],
			"Non-MSM:<30": [
				41,
				37,
				35,
				33,
				25,
				18
			],
			"Non-MSM:30-39": [
				245,
				239,
				230,
				219,
				178,
				118
			],
			"Non-MSM:40-49": [
				539,
				532,
				524,
				505,
				445,
				282
			],
			"Non-MSM:>=50": [
				1686,
				1653,
				1583,
				1522,
				1417,
				1054
			],
			"Unknown:<30": [
				200,
				108,
				98,
				94,
				81,
				63
			],
			"Unknown:30-39": [
				320,
				272,
				242,
				230,
				205,
				151
			],
			"Unknown:40-49": [
				647,
				565,
				438,
				420,
				382,
				309
			],
			"Unknown:>=50": [
				2385,
				2038,
				1426,
				1359,
				1300,
				1079
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_5.json
// module id = 170
// module chunks = 0